import { useState, useContext, useCallback} from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {ChangePassword} from './ChangePassword.js';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { UserContext } from './context.js';
import { APIToken } from './apiToken.js';
import { Subscription } from './subscription.js';
import { CreateNestingButton, GroupList2 } from './nestingList.js';
import NestingMenu from './menu.js';
import {style} from './style.js';
import LifeBar from './lifeBar.js';
import Modal from '@mui/material/Modal';

function getMenuContent(modal, setModal){
  if(modal === 1){
    return (<GroupList2 onGroup={()=>setModal(0)}/>);
  }else if (modal === 2){
    return (<AccountImpl/>) ;
  }
}

export function Topbar(){
  const [modal, setModal] = useState(0);
	const [user, setUser] = useContext(UserContext);
  const [menuOpen, setMenuOpen] = useState(false);
  let href;
  if(process.env.REACT_APP_HTTP_SERVER){
    href = process.env.REACT_APP_HTTP_SERVER + "/api";
  }else{
    href = "https://" + window.location.hostname + "/api";
  }
	async function logout(){
		let response = await fetch("/accounts/api/logout/");
		if(response.ok){
			setUser(await response.json());
		}
	}
  const modalContent = getMenuContent(modal, setModal);
	return (
		<AppBar position="static">
      <Toolbar>
        <Box sx={{flexGrow: 0}}>
          <NestingMenu
            open={menuOpen}
            onOpen={()=>{
              setMenuOpen(true)
            }}
            onClose={()=>{
              setMenuOpen(false)
            }}
          >
            <MenuItem>
              <CreateNestingButton onClick={()=>setMenuOpen(false)}/> 
            </MenuItem>
            <MenuItem
              onClick={() =>{
                setMenuOpen(false);
                setModal(1);
                }}
            >
              <Typography color="secondary">Load previous nesting</Typography>
            </MenuItem>
            <MenuItem
              onClick={() =>{
                setMenuOpen(false);
                setModal(2);
              }}
            >
                <Typography color="secondary">My Account</Typography>
            </MenuItem>
            <MenuItem
              component={Link}
              href={href}
              rel="noopener noreferrer"
              target="_blank"
            >
                <Typography color="secondary">Browsable API</Typography>
                <ExitToAppIcon color="secondary"/>
            </MenuItem>
          </NestingMenu>
        </Box>
        <Box sx={{flexGrow: 1}}>
        <LifeBar/>
        </Box>
        <Box sx={{flexGrow: 0}}>
          <Typography component="span">Hello: </Typography>
          <Typography
           component="span"
            color='secondary'
          >
            {user.username}
          </Typography>
          <Typography component="span"> / </Typography>
          <Button color='secondary' component={Link} onClick={logout}>Logout</Button>
        </Box>
      </Toolbar>
      <Modal open={Boolean(modal)} onClose={()=>setModal(0)}>
          <Box sx={{width: "600px", height: "800px", ...style}}>
            {modalContent}
          </Box>
      </Modal>
		</AppBar>
	)
}

export function AccountImpl(){
	const user = useContext(UserContext)[0];
  const [accordionOpen, _setAccordionOpen] = useState(0);
  const setAccordionOpen = useCallback((acc) => {
    if(acc === accordionOpen){
      _setAccordionOpen(0);
    }else{
      _setAccordionOpen(acc);
    }
  }, [_setAccordionOpen, accordionOpen]);
	let mailto = "mailto:" + user.email;
  let subscription;
  if(user.owner){
    subscription = (
      <Accordion expanded={accordionOpen === 3}  TransitionProps={{ unmountOnExit: true }}>
        <AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					onClick={() => setAccordionOpen(3)}
				>
          Manage Subscription
				</AccordionSummary>
        <AccordionDetails>
          <Subscription/>
        </AccordionDetails>
      </Accordion>
    );
  }
	return (
		<>
			<Typography align="left">Your username is: {user.username}</Typography>
			<Typography align="left">Your email is: <Link href={mailto}>{user.email}</Link></Typography>
			<Accordion expanded={accordionOpen === 1}  TransitionProps={{ unmountOnExit: true }}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					onClick={() => setAccordionOpen(1)}
				>
					Change Password
				</AccordionSummary>
				<AccordionDetails>
					<ChangePassword onSuccess={() => setAccordionOpen(0)}/>
				</AccordionDetails>
			</Accordion>
      <Accordion expanded={accordionOpen === 2}  TransitionProps={{ unmountOnExit: true }}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					onClick={() => setAccordionOpen(2)}
				>
					API Token
				</AccordionSummary>
				<AccordionDetails>
          <APIToken/>
				</AccordionDetails>
      </Accordion>
      {subscription}
		</>
	)
}
